<script>
import service from '@/service';
import DatumFilterDropdown from '@/components/DatumFilterDropdown';
import VirFilterDropdown from '@/components/DropdownFilters/VirPrilivaDropdown';
import ZnesekFilterDropdown from '@/components/DropdownFilters/ZnesekDropdown';
import UvoziPrilivModal from '@/components/Modals/UvoziPrilivModal';
import EditPrilivModal from '@/components/Modals/EditPrilivModal';
import settings from '@/settings.js';

export default {
	name: 'prilivi',
	components: {
		'datum-filter-dropdown': DatumFilterDropdown,
		'vir-filter-dropdown': VirFilterDropdown,
		'znesek-filter-dropdown': ZnesekFilterDropdown,
		'uvozi-priliv-modal': UvoziPrilivModal,
		'edit-priliv-modal': EditPrilivModal
	},
	filters: {
	},
	methods: {
		click_openUvoziPrilive: function ($event) {
			this.showError(null);
			this.$refs.uvoziModal.showModal();
		},
		click_editPriliv: function (priliv) {
			this.showError(null);
			this.$refs.editPrilivModal.showModal(priliv, false);
		},
		click_removePriliv: function (priliv) {
			this.$bvModal.msgBoxConfirm('Želite izbrisati priliv #' + priliv.id + '?', {
				title: 'Potrdite brisanje priliva',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'DA',
				cancelTitle: 'NE',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (value === true) {
					service.removePriliv(priliv.id)
						.then(response => {
							this.table.items = this.table.items.filter(function (value, index, arr) {
								return value.id !== priliv.id;
							});
							this.showError(null);
							this.$refs.dataTable.refresh();
						})
						.catch(error => {
							this.showError('Napaka odstranjevanju priliva!');
							if (error) {
								console.log(error);
							}
						});
				}
			}).catch(err => {
				console.log(err);
			})
		},
		table_rowClick: function (item, index) {
			this.showError(null);
		},
		table_dataProvider: function (ctx) {
			return service.getPriliviFiltered(ctx, this.inputFilter, this.user)
				.then(data => {
					this.items = data;
					this.table.totalRows = data.total;
					return this.items.data;
				})
				.catch(error => {
					if (error) {
						console.log(error);
					}
					this.totalRows = 0;
					return [];
				});
		},
		table_filterChange: function (value) {
			if (this.filterPriliviTimeout !== null) {
				clearTimeout(this.filterPriliviTimeout);
			}
			this.filterPriliviTimeout = setTimeout(() => {
				this.$refs.dataTable.refresh();
			}, settings.filterTimeoutLength);
		},
		table_virFilterChange: function (selectedItems) {
			if (selectedItems && selectedItems.length > 0) {
				this.inputFilter.vir = [];
				for (let item of selectedItems) {
					this.inputFilter.vir.push(item.value);
				}
			} else {
				this.inputFilter.vir = null;
			}
			this.$refs.dataTable.refresh();
		},
		on_priliviPotrjeniSuccess: function () {
			this.$refs.dataTable.refresh();
		},
		edit_add: function () {
			this.$refs.dataTable.refresh();
			this.$refs.toastr.s('Priliv dodan');
		},
		edit_update: function () {
			this.$refs.dataTable.refresh();
			this.$refs.toastr.s('Priliv posodobljen');
		},
		showError: function (message) {
			if (message) {
				this.message.type = this.MESSAGE_TYPE_ERROR;
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		}
	},
	data: () => {
		return {
			table: {
				items: [],
				fields: [
					{ key: 'datum', label: 'Datum', sortable: true, class: 'seznamPrilivovDatum' },
					{ key: 'ogrodje', label: 'Ogrodje', sortable: true, class: 'seznamPrilivovOgrodje' },
					{ key: 'placnik', label: 'Stranka', sortable: true },
					{ key: 'naziv', label: 'Naziv', sortable: true },
					{ key: 'referenca', label: 'Referenca', sortable: true },
					{ key: 'znesek', label: 'Znesek', sortable: true, class: 'seznamPrilivovZnesek' },
					{ key: 'vir', label: 'Vir', sortable: true, class: 'seznamPrilivovVir' },
					{ key: 'actions', label: '#', class: 'seznamPrilivovActions' }
				],
				currentPage: 1,
				perPage: 50,
				totalRows: 0,
				sortDesc: true,
				sortBy: 'created_at',
				filter: null
			},
			inputFilter: {
				datum: null,
				ogrodje: '',
				placnik: '',
				naziv: '',
				referenca: '',
				znesek: null,
				vir: null
			},
			filterPriliviTimeout: null,
			message: {
				type: null,
				text: null
			},
			MESSAGE_TYPE_ERROR: 'ERROR'
		};
	},
	computed: {
		user () {
			return this.$store.getters.user;
		},
		message_class () {
			if (this.show_step_two) {
				return 'error_message_b';
			}
			return 'error_message';
		}
	},
	created () {
		/* let $main = this;
		this.$nextTick(() => {
			$main.$refs.uvoziModal.showModal();
		}); */
	}
};
</script>
<template>
	<div class="animated fadeIn">
		<b-alert :class="message_class" :variant="message.type && message.type === MESSAGE_TYPE_ERROR ? 'danger' : 'primary'" :show="message.text && message.text !== ''">{{ message.text }}</b-alert>
		<b-row>
			<b-col lg="12">
				<b-card>
					<div slot="header">
						<i class='icon-wallet'></i> Prilivi
						<div class="card-actions">
							<a href="#uvoziPrilive" class="btn btn-setting" @click.prevent="click_openUvoziPrilive($event)"><i class="icon-cloud-upload"></i></a>
							<a href="#urediPrliv" class="btn btn-setting" @click.prevent="click_editPriliv()"><i class="icon-plus"></i></a>
						</div>
					</div>
					<b-table
						ref="dataTable"
						responsive="sm"
						show-empty
						hover
						empty-text="Ni vnosov"
						empty-filtered-text="Ni zadetkov"
						:items="table_dataProvider"
						:fields="table.fields"
						:current-page="table.currentPage"
						:per-page="table.perPage"
						:filter="table.filter"
						:sort-by.sync="table.sortBy"
						:sort-desc.sync="table.sortDesc"
						@row-clicked="table_rowClick">
						<template slot="znesek" slot-scope="data">
							<span> {{ data.item.znesek | hr_money }}</span>
						</template>
						<template slot="datum" slot-scope="data">
							<span>  {{ data.item.datum | hr_date }} </span>
						</template>
						<template slot="actions" slot-scope="data">
							<b-button ref="editPriliv" class="m-1 seznamPrilivovIconStyle" variant="primary" @click.stop="click_editPriliv(data.item)" size="sm">
								<i class="fa fa-pencil-square-o"></i>
							</b-button>
							<b-button ref="removePriliv" class="m-1 seznamPrilivovIconStyle" variant="danger" @click.stop="click_removePriliv(data.item)" size="sm">
								<i class="fa fa-remove"></i>
							</b-button>
						</template>
						<template slot="top-row">
							<td><datum-filter-dropdown v-model="inputFilter.datum" @input="table_filterChange" /></td>
							<td><b-form-input v-model="inputFilter.ogrodje" type="text" @input="table_filterChange" /></td>
							<td><b-form-input v-model="inputFilter.placnik" type="text" @input="table_filterChange" /></td>
							<td><b-form-input v-model="inputFilter.naziv" type="text" @input="table_filterChange" /></td>
							<td><b-form-input v-model="inputFilter.referenca" type="text" @input="table_filterChange" /></td>
							<td><znesek-filter-dropdown v-model="inputFilter.znesek" @input="table_filterChange" />  </td>
							<td><vir-filter-dropdown ref="virPicker" @change="table_virFilterChange" /></td>
							<td></td>
						</template>
					</b-table>
					<nav>
						<b-pagination :total-rows="table.totalRows" :per-page="table.perPage" v-model="table.currentPage" prev-text="Prejšnja" next-text="Naslednja" hide-goto-end-buttons />
					</nav>
				</b-card>
			</b-col>
		</b-row>
		<vue-toastr ref="toastr"></vue-toastr>
		<uvozi-priliv-modal v-on:priliviPotrjeni-success="on_priliviPotrjeniSuccess" ref="uvoziModal" />
		<edit-priliv-modal @priliv_add="edit_add" @priliv_edit="edit_update" ref="editPrilivModal" />
	</div>
</template>
<style scoped>

</style>
<style>
.seznamPrilivovDatum {
	width: 120px;
}
.seznamPrilivovOgrodje {
	width: 180px;
}
.seznamPrilivovZnesek {
	width: 120px;
}
.seznamPrilivovVir {
	width: 80px;
}
.seznamPrilivovActions {
	width: 120px;
}
.seznamPrilivovIconStyle {
	min-width: 35px;
}
.b-table-top-row .form-control {
	padding: 0.375rem 0.375rem;
}
.dropdown-toggle::after {
	border: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Prilivi.vue